export default {
    label_task:{
        en:"Business Plan 3 Years Report",
        bn:'Variety Report'
    },

    label_num_fiscal_years :{
        en:"Num of Fiscal Year",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
}